import React, { memo } from "react";
import styles from "./unsubscribeByBatch.module.scss";
import CustomDialogUploadFile from "../../../shared/components/CustomDialogUploadFile";
import SVG from "react-inlinesvg";
import { useTranslation } from "react-i18next";
import { api } from "../../../app/conf";
import { downloadSVG } from "../../../shared/helpers/icons";

const UnsubscribeByBatch = ({
    open,
    onClose,
    submitFetching,
    submitAction,
    title,
    subTitle,
    type,
    itemsToLoadAfterValidating,
    showItemToLoad,
    errors
}) => {
    const { t } = useTranslation(["home", "devices"]);

    const buildFormData = (file) => {
        const data = new FormData();
        data.append("file", file);
        data.append("tz", new Date().getTimezoneOffset());

        return data;
    };

    const handleOnSubmit = (file) => {
        const data = buildFormData(file);

        submitAction(data);
    };

    return (
        <CustomDialogUploadFile
            open={open}
            onClose={onClose}
            title={title}
            subTitle={subTitle}
            onSubmit={handleOnSubmit}
            typesFile={"xslx"}
            submitFetchingFile={submitFetching}
            itemsToLoadAfterValidating={itemsToLoadAfterValidating}
            showItemToLoad={showItemToLoad}
            type={type}
            downloadExample={
                <div className={styles.link}>
                    <a
                        href={`${api}/examples/${type}.xlsx`}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                    >
                        <SVG src={downloadSVG} />
                        {t("devices:download_example_file")}
                    </a>
                </div>
            }
        />
    );
};

export default memo(UnsubscribeByBatch);
